import { render, staticRenderFns } from "./RewardsChart.vue?vue&type=template&id=353286b7&scoped=true"
import script from "./RewardsChart.vue?vue&type=script&lang=js"
export * from "./RewardsChart.vue?vue&type=script&lang=js"
import style0 from "./RewardsChart.vue?vue&type=style&index=0&id=353286b7&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353286b7",
  null
  
)

export default component.exports